<template>
    <v-container fluid class="grey lighten-5 my-0 px-0  py-0">
        <v-row class="mx-5">
            <v-col cols="12">
                <CategoriesDataTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QCategoriesDataTable from '@/components/datatables/QCategoriesDataTable.vue'
import { QDraggableList, QButton } from '@/modules/shared'
import { CategoriesDataTable  } from '@/modules/CMS/categories/'

export default {
    props: ['isPopup', 'justLink'],
    name: 'categoriesView',
    data() {
        return {
            loading: false,
            categoriesList: [],
            search: null,
            rows: 100,
            CategoryName: null,
        }
    },
    components: {
        QCategoriesDataTable,
        QDraggableList,
        QButton,
        CategoriesDataTable
    }
}
</script>
